module.exports = __webpack_public_path__ + "img/2-3.272db3b2.svg";